module.exports = __webpack_public_path__ + "assets/img/pay-way.bc65e5c0.png";